import {Linking, Platform} from 'react-native';

import {config} from '../config';

import {setValueToStorage} from './localStorage';

const E2E_SERVER_SESSION_QUERY_PARAM = 'e2eServerSessionId';
const SERVER_SESSION_ID = 'SERVER_SESSION_ID';

export const maybeSeedE2eSessionFromLaunchUrl = async (): Promise<void> => {
  if (config.ENV !== 'DEV' || Platform.OS === 'web') {
    return;
  }

  const raw = await Linking.getInitialURL();
  if (!raw) {
    return;
  }

  let sessionId: string | null;
  try {
    sessionId = new URL(raw).searchParams.get(E2E_SERVER_SESSION_QUERY_PARAM);
  } catch {
    return;
  }

  if (!sessionId) {
    return;
  }

  await setValueToStorage(SERVER_SESSION_ID, sessionId);
};
